
function HandleThemeOverrideParams() {
  const queryParams = new URLSearchParams(window.location.search);
  const rootStyles = document.documentElement.style;


  function FuckColorsUp() {
    const themeGold = queryParams.get('theme_gold');
    const themeWhite = queryParams.get('theme_white');
    const backgroundBlack = queryParams.get('background_black');
    const menuPurple = queryParams.get('menu_purple');
    const bullGreen = queryParams.get('bull_green');
    const bearRed = queryParams.get('bear_red');

    if (themeGold) rootStyles.setProperty('--color-theme-gold', '#' + themeGold);
    if (themeWhite) rootStyles.setProperty('--color-theme-white', '#' + themeWhite);
    if (backgroundBlack) rootStyles.setProperty('--color-black', '#' + backgroundBlack);
    if (menuPurple) rootStyles.setProperty('--color-menu-purple', '#' + menuPurple);
    if (bullGreen) rootStyles.setProperty('--color-bull-green', '#' + bullGreen);
    if (bearRed) rootStyles.setProperty('--color-bear-red', '#' + bearRed);
  }


  function FuckBackgroundsUp() {
    const pageBG = queryParams.get('page_bg');
    const menuBG = queryParams.get('menu_bg');

    if (pageBG) {
      if (pageBG.includes('http')) {
        rootStyles.setProperty('--gradient-page-bg', 'url(' + decodeURIComponent(pageBG) + ')');
      } else if (pageBG.length > 8) {
        let direction = pageBG[0];
        const color1 = pageBG.slice(1, 9);
        const color2 = pageBG.slice(9, 17);
        direction = GetExpandedDirection(direction);
        rootStyles.setProperty('--gradient-page-bg',
          'linear-gradient(to ' + direction + ', #' + color1 + ', #' + color2 + ')');
      } else {
        rootStyles.setProperty('--gradient-page-bg', '#' + pageBG);
      }
    }

    if (menuBG) {
      if (menuBG.includes('http')) {
        rootStyles.setProperty('--gradient-navbar-bg', 'url(' + decodeURIComponent(menuBG) + ')');
      } else if (menuBG.length > 8) {
        let direction = menuBG[0];
        const color1 = menuBG.slice(1, 9);
        const color2 = menuBG.slice(9, 17);
        direction = GetExpandedDirection(direction);
        rootStyles.setProperty('--gradient-navbar-bg',
          'linear-gradient(to ' + direction + ', #' + color1 + ', #' + color2 + ')');
      } else {
        rootStyles.setProperty('--gradient-navbar-bg', '#' + menuBG);
      }
    }

  }


  FuckColorsUp();
  FuckBackgroundsUp();
}


function GetExpandedDirection(direction) {
  if (!direction) throw new SyntaxError('missing required argument: direction');

  let expandedDirection;
  switch (direction) {
    case 'b':
      expandedDirection = 'bottom'
      break;
    case 't':
      expandedDirection = 'top'
      break;
    case 'r':
      expandedDirection = 'right'
      break;
    case 'l':
      expandedDirection = 'left'
      break;
    default:
      expandedDirection = 'bottom'
      break;
  }
  return expandedDirection;
}

export default HandleThemeOverrideParams;